import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M403.240649 739.274524c-13.007763 0-25.292872-5.058574-34.687367-14.45307-0.722653-0.722653-0.722653-1.445307-1.445307-1.445307L191.503176 507.302752c-7.949188-9.394495-6.503881-23.847565 3.613267-31.796753 9.394495-7.949188 23.847565-6.503881 31.796754 3.613267L401.072689 693.747354c1.445307 1.445307 2.890614 1.445307 5.058574-0.722654l384.451659-409.021877c8.671842-9.394495 23.124912-9.394495 31.796753-0.722654 9.394495 8.671842 9.394495 23.124912 0.722654 31.796754l-385.174312 409.744531c-9.394495 9.394495-21.679605 14.45307-34.687368 14.45307z\" p-id=\"1654\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/right.svg
// module id = 9iyg
// module chunks = 76